import issuedVehiclePermitsService from '@/api/issued-vehicle-permits-service';

export const getDefaultIssuedVehiclePermitFilterParams = () => ({});

const state = {
  issuedVehiclePermits: null,
  issuedVehiclePermitsPagination: {},
  // issuedVehiclePermitValidationErrors: {},
  issuedVehiclePermitsFilterParams: getDefaultIssuedVehiclePermitFilterParams(),
};

const mutations = {
  SET_ISSUED_VEHICLE_PERMITS(state, { data, current_page, per_page, total }) {
    state.issuedVehiclePermits = data;
    state.issuedVehiclePermitsPagination = {
      current_page,
      per_page,
      total,
    };
  },

  SET_FILTER_PARAMS(state, params) {
    state.issuedVehiclePermitsFilterParams = params;
  },

  // SET_ISSUED_VEHICLE_PERMIT_VALIDATION_ERRORS(state, validationErrors) {
  //   state.issuedVehiclePermitValidationErrors = validationErrors;
  // },

  // RESET_ISSUED_VEHICLE_PERMIT_VALIDATION_ERRORS(state) {
  //   state.issuedVehiclePermitValidationErrors = {};
  // },

  CLEAR_VALIDATION_ERRORS(state, field) {
    delete state.issuedVehiclePermitValidationErrors[field];
  },
};

const actions = {
  fetchIssuedVehiclePermits({ commit }, params) {
    commit('SET_FILTER_PARAMS', params);
    return issuedVehiclePermitsService.getPage(params).then((res) => {
      commit('SET_ISSUED_VEHICLE_PERMITS', res.data);
      return res.data;
    });
  },

  // clearIssuedVehiclePermitsValidationErrors({ commit }, field) {
  //   commit('CLEAR_VALIDATION_ERRORS', field);
  // },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
